// extracted by mini-css-extract-plugin
export var container = "styles-module__container___LmRiz";
export var imageContainer = "styles-module__imageContainer___ZRQhZ";
export var image = "styles-module__image___kHldn";
export var title = "styles-module__title___Iz4FY";
export var subText = "styles-module__subText___DvJla";
export var content = "styles-module__content___os5AP";